import React from 'react';
import { ChevronLeft } from 'lucide-react';

const CreatePrescription = ({ onBack }) => {
    return (
        <div className="h-full flex flex-col overflow-hidden">
             {/* Header */}
             <div className="p-4 border-b border-gray-100 flex items-center gap-2 bg-white">
                <button 
                    onClick={onBack}
                    className="p-1 hover:bg-gray-100 rounded-full transition-colors"
                    aria-label="Back to details"
                >
                    <ChevronLeft size={20} className="text-gray-600" />
                </button>
                <h3 className="font-semibold text-gray-800 text-lg m-0">Create Prescription</h3>
            </div>
            
            <div className="flex-1 flex items-center justify-center text-gray-400 p-4">
                <p>Prescription form content will go here.</p>
            </div>
        </div>
    );
};

export default CreatePrescription;
